import { IVideo } from "@faire/web-api/indigofair/data/IVideo";
import getMinutes from "date-fns/getMinutes";
import setMilliseconds from "date-fns/setMilliseconds";
import startOfHour from "date-fns/startOfHour";
import max from "lodash/max";

export const formatVideoDuration = (video: IVideo) =>
  getMinutes(
    setMilliseconds(
      startOfHour(new Date()),
      max([video.duration_millis, 60 * 1_000])!
    )
  );
